import React from 'react';
import { Link } from 'react-router-dom';
import { useApp } from '../../contexts/AppContext';

export const AppFooter = () => {
  const { 
    getAppName, 
    getSecondaryColor, 
    getFooterTabs,
    hasFeature 
  } = useApp();

  const footerTabs = getFooterTabs();
  const showFooter = hasFeature('footer');

  if (!showFooter) {
    return null;
  }

  return (
    <footer
      style={{
        backgroundColor: getSecondaryColor(),
        padding: '2rem 1rem',
        color: 'white',
        marginTop: 'auto'
      }}
    >
      <div style={{ 
        maxWidth: '1200px',
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column',
        gap: '2rem'
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-around',
          flexWrap: 'wrap',
          gap: '2rem'
        }}>
          {footerTabs.map((tab) => (
            <div key={tab.title}>
              <h3 style={{ marginBottom: '1rem' }}>{tab.title}</h3>
              <ul style={{ 
                listStyle: 'none', 
                padding: 0,
                margin: 0,
                display: 'flex',
                flexDirection: 'column',
                gap: '0.5rem'
              }}>
                {tab.links.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      style={{
                        color: 'white',
                        textDecoration: 'none',
                        ':hover': {
                          textDecoration: 'underline'
                        }
                      }}
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div style={{
          borderTop: '1px solid rgba(255, 255, 255, 0.1)',
          paddingTop: '1rem',
          textAlign: 'center'
        }}>
          <p style={{ margin: 0 }}>
            © {new Date().getFullYear()} {getAppName()}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}; 